(function($) {
    'use strict';

    /**
     * Обыкновенные табы
     * @param {object} [options] - объект с настройками
     * @param {number} options.activeIndex - индекс слайда, активируемого при инициализации
     * @param {string} options.activeId - идентификатор слайда, активируемого при инициализации (приоритетнее, чем options.activeIndex)
     * @returns {boolean}
     */
    $.fn.simpleTabs = function (options) {
        var defaults = {
            activeIndex: 0,
            activeId: ''
        };
        var settings = $.extend({}, defaults, options);

        var $container = $(this);
        var $headers = $container.find('.js-tab-header');
        var $content = $container.find('.js-tab-content');
        var $subContent = $container.find('.js-tab-sub-content');

        /**
         * Активировать таб по индексу
         * @param {number} index - индекс активируемого таба
         */
        var activateTabByIndex = function(index) {
            $headers.removeClass('active').eq(index).addClass('active');
            $content.removeClass('active').eq(index).addClass('active');
            $subContent.removeClass('active').eq(index).addClass('active');
        };

        /**
         * Активировать таб по идентификатору
         * @param {string} id - идентификатор активируемого таба
         */
        var activateTabById = function(id) {
            $headers.removeClass('active').filter('[data-tab-id="' + id + '"]').addClass('active');
            $content.removeClass('active').filter('#' + id).addClass('active');
            $subContent.removeClass('active').filter('#' + id).addClass('active');
        };

        /**
         * Инициализация
         */
        var init = function() {
            if (settings.activeId) {
                activateTabById(settings.activeId);
            } else {
                activateTabByIndex(settings.activeIndex);
            }

            $container.on('click', '.js-tab-header', function(e) {
                var $t = $(this);

                if (typeof $t.data('tab-id') !== 'undefined') {
                    activateTabById($t.data('tab-id'));
                } else {
                    activateTabByIndex($t.index());
                }
            });
        };

        init();

        this.activateTabByIndex = activateTabByIndex;
        this.activateTabById = activateTabById;

        return true;
    };
})(jQuery);
